module.exports = __webpack_public_path__ + "static/ethos-automation-logo-2957170e7fb0672cd3afc15d7dfd6580.jpeg";